import React, { Component } from "react";
import moment from "moment";
export default class CommunicationItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div key={this.props.communication.id} className="card mb-2" data-testid={`activity-${this.props.communication.id}`}>
        <div style={{ padding: "3px", margin: "1px" }} className={"card-ticket-communication  row rounded-top"}>
          <div className="col-8">{"Communication by " + this.props.communication.created_by}</div>
        </div>
        <div className="card-body">
          <div className="row d-flex">
            <div dangerouslySetInnerHTML={{ __html: this.props.communication.note }} />
          </div>
        </div>
        <div className="card-footer">
          <small>
            <div className="d-flex justify-content-between">
              <span>{moment(this.props.communication.created).format("DD MMMM YYYY HH:mm")}</span>
              {/* <span>{this.props.activity.created_by && `by ${this.props.activity.created_by}`}</span> */}
            </div>
          </small>
        </div>
      </div>
    );
  }
}
